import React, { useState, useEffect } from 'react'
import { call } from '../Methods'

function About () {
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const contentKey = 'Page.about'

  const getData = async () => {
    setLoading(true)
    const _aboutPage = await call.content.getContents({
      fullName: contentKey
    })
    setContent(_aboutPage)
    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, [])

  if (loading) return <div className='loading'>Loading...</div>
  if (!content) return <div className='loading'>Something wrong happen...</div>
  return (
    <>
      <div className='page about-page'>
        <div className='page-content text-content'>
          <div className='page-header'>
            <h1 className='main'>About Us</h1>
          </div>
          <p className="paragraph" dangerouslySetInnerHTML={{ __html: content.value }}></p>
        </div>
      </div>
    </>
  )
}

export default About
